var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09684 10.5937C7.81787 13.9087 10.567 16.6026 13.9487 18.2892L16.5707 15.7114C16.8995 15.3888 17.3682 15.2968 17.7804 15.4254C19.1118 15.8573 20.5482 16.0917 22.0312 16.0917C22.6922 16.0917 23.2227 16.6122 23.2227 17.2608V21.3519C23.2227 22.0005 22.6922 22.521 22.0312 22.521C10.8433 22.521 1.77734 13.6266 1.77734 2.64926C1.77734 2.00408 2.31127 1.48022 2.96886 1.48022H7.13869C7.79971 1.48022 8.3302 2.00071 8.3302 2.64926C8.3302 4.1043 8.5692 5.51408 9.00939 6.82226C9.14042 7.2243 9.04669 7.68748 8.71789 8.01008L6.09684 10.5942V10.5937Z",
    fill: "#45AF77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.c60172b681d238d559cee7cf07038e83.svg";
export { ForwardRef as ReactComponent };